module.exports = __webpack_public_path__ + "static/media/path-294-at-1x.3021d40d.webp";